// helpers.
const status = ['Pendiente', 'En Progreso', 'Concluido', 'Atrasado']

// main function.
const cardStatusFormat = (num) => {
  return status[num]
}

export default cardStatusFormat
